"use client";
import BupiLink from "@/components/atoms/link";
import { Scribbles } from "@ama-pt/agora-design-system";
import React from "react";

const FooterOtherPortalsSection = ({ title, portals }: any) => {
  return (
    <div className="w-full xl:-mt-120 xl:container-30 bg-primary-600 flex xs:py-32 xs:pl-0 xl:py-64 xl:pl-64 z-[1]">
      <div className="flex-grow container mx-auto ">
        <div className="xl:w-[360px] text-white"></div>
        <div className="text-m-bold md:text-l-bold text-white">
          <div>
            <div>
              <h2 className="whitespace-break-spaces !text-m-bold md:!text-l-bold xl:!text-l-bold !text-white">
                {title}
              </h2>
              <Scribbles name="agora-line-zig" darkMode aria-hidden />
            </div>
          </div>
        </div>
        <nav aria-label="Outros portais">
          <ul className="mt-32 md:grid md:grid-cols-2 xl:grid-cols-1 md:gap-x-32">
            {portals.map((portal: any, index: number) => (
              <li key={index} className="py-8">
                 <BupiLink
                    label={portal.label}
                    url={portal.href}
                    hasIcon
                    className="agora-anchor agora-anchor-link-neutral inline-flex items-center justify-between gap-8  text-white min-h-[44px] min-w-[44px] py-8 dark-mode"
                    target={portal.target}
                  />
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default FooterOtherPortalsSection;
